
import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { isNull } from '../utils/index';

export interface PaginationProps extends BaseComponentProps {
    totalCount: number;
    /**
     * page awal
     */
    initialPage?: number;
    /**
     * ukuran page
     */
    pageSize: number;
    /**
     * page yang akan di baca
     */
    page: number;
    /**
     * handler kalau page beurubah 
     */
    onChangePage: (data: number, dari: string) => any;

    /**
     * jumlah tombol page yang akan di tampikkan di bawah. default 5
     */
    numberOfDisplayedPage?: number;
}
export interface PaginationState extends BaseComponentState {
    pageCount: number;
}

export class Pagination extends BaseComponent<PaginationProps, PaginationState> {
    /**
     * jumlah page yang di tampilkan(tombol page)
     */
    static DEFAULT_DISPLAYED_PAGE: number = 5;
    constructor(props: PaginationProps) {
        super(props);
        this.state = { pageCount: Math.ceil(props.totalCount / props.pageSize) };
    }

    componentDidUpdate(prevProps: PaginationProps, prevState: PaginationState) {
        // reset page if items array has changed
        if (this.props.page !== prevProps.page && this.props.totalCount !== prevProps.totalCount) {
            this.setStateHelper(st => {
                st.pageCount = Math.ceil(this.props.totalCount / this.props.pageSize);
            });
        }
    }

    render() {
        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
        let pageCount = 0;
        if (!isNull(this.props.totalCount) && !isNull(this.props.pageSize)) {
            pageCount = Math.ceil(this.props.totalCount / this.props.pageSize);
        }

        // console.log("this.props.totalCount ", this.props.totalCount, this.props.pageSize);
        return (
            <ul className="pagination">
                <li className={this.props.page === 0 || isNull(this.props.totalCount) ? 'disabled' : ''}>
                    <a onClick={() => this.props.onChangePage(0, " Dari Paging")}>First</a>
                </li>
                <li className={this.props.page === 0 || isNull(this.props.totalCount) ? 'disabled' : ''}>
                    <a onClick={() => this.props.onChangePage(this.props.page - 1, " Dari Paging")}>Previous</a>
                </li>
                {this.renderPageButton()}
                <li className={this.props.page === this.state.pageCount - 1 || isNull(this.props.totalCount) ? 'disabled' : ''}>
                    <a onClick={() => this.props.onChangePage(this.props.page + 1, " Dari Paging")}>Next</a>
                </li>
                <li className={this.props.page === pageCount - 1 || isNull(this.props.totalCount) ? 'disabled' : ''}>
                    <a onClick={() => this.props.onChangePage(pageCount - 1, " Dari Paging")}>Last</a>
                </li>
            </ul>
        );
    }

    renderPageButton(): JSX.Element[] {
        let pageCount = 0;
        if (!isNull(this.props.totalCount) && !isNull(this.props.pageSize)) {
            pageCount = Math.ceil(this.props.totalCount / this.props.pageSize);
        }
        let propPage = this.props.page / 1;
        if (this.props.totalCount) {
            let nPage: number = Math.ceil(this.props.totalCount / this.props.pageSize);
            if (nPage === 1) {
                let ret: any = null;
                return ret;
            }
            let pgBtnToDisplay: number = this.props.numberOfDisplayedPage ? this.props.numberOfDisplayedPage / 1 : Pagination.DEFAULT_DISPLAYED_PAGE / 1;
            if (pgBtnToDisplay % 2 === 0) {
                pgBtnToDisplay += 1;
            }
            let btns: number[] = [];
            if (nPage <= pgBtnToDisplay) {
                for (let i = 1; i <= nPage; i++) {
                    btns.push(i);
                }
            } else {
                let blk: number = Math.floor(pgBtnToDisplay / 2);
                let tbhDpn = 0;
                tbhDpn = blk;
                if (propPage + blk >= pageCount) {
                    tbhDpn = pageCount - (propPage + blk) + 1; 
                    blk += propPage + blk  - pageCount + 1;
                } 
                for (let i2 = blk; i2 > 0; i2--) {
                    if (propPage - i2 < 0) {
                        tbhDpn++;
                    } else {
                        btns.push(propPage - i2);
                    }
                }
                for (let i3 = 1; i3 <= tbhDpn; i3++) {
                    btns.push(propPage + i3);
                }
            }
            btns.push(propPage);

            btns.sort((n1: number, n2: number) => {
                if (n1 === n2) {
                    return 0;
                }
                return n1 > n2 ? 1 : -1;
            });

            let s: any = btns.map(pg => {
                return (
                    <li key={'btn_page_' + pg} className={propPage === pg ? 'disabled' : ''}>
                        <a onClick={() => this.props.onChangePage(pg, " Dari Paging")} title={'actual page : ' + pg}>{pg + 1}</a>
                    </li>);
            });
            return s;
        }
        let ss: any = null;
        return ss;
    }
}


// WEBPACK FOOTER //
// ./src/core/Pagination.tsx